import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import TextField from "components/TextField";
import { useEffect, useRef } from "react";
import { useForm, useWatch } from "react-hook-form";

const SearchField = ({
  setValueCallback,
  delay = 1000,
  placeholder = "جستجو...",
  name = "search",
  filterIcon = false,
  ...props
}) => {
  const { control } = useForm({
    mode: "onChange",
    defaultValues: {
      [name]: "",
    },
  });

  const watchedValue = useWatch({ control, name: name });
  const timeoutRef = useRef(null);

  useEffect(() => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setValueCallback(watchedValue);
    }, delay);

    return () => clearTimeout(timeoutRef.current);
  }, [watchedValue]);

  return (
    <TextField
      control={control}
      name={name}
      placeholder={placeholder}
      fullWidth
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="start">
              {filterIcon ? <FilterAltIcon /> : <SearchIcon />}
            </InputAdornment>
          ),
        },
      }}
      {...props}
    />
  );
};

export default SearchField;
